// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

const updatePoNumbersUrl = "/api/guest/cartline/ponumbers";

export interface PoLineModel {
    cartLineId: string;
    PoNumber: string;
}

export async function updatePoNumbers(parameter: PoLineModel[]) {
    try {
        const updatePoNumbersResult = await post<any>(`${updatePoNumbersUrl}`, parameter);
        return {
            result: updatePoNumbersResult,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.errorJson?.message,
        };
    }
}
